import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const WorkspaceSettingsVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceSettingsVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"me"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissionLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enterprise"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationPrefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissionLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"idAdmins"}}]}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"WorkspaceSettingsVisibility","document":WorkspaceSettingsVisibilityDocument}} as const;
export type WorkspaceSettingsVisibilityQueryVariables = Types.Exact<{
  orgId: Types.Scalars['ID'];
}>;


export type WorkspaceSettingsVisibilityQuery = (
  { __typename: 'Query' }
  & { organization?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'id'>
    & { memberships: Array<(
      { __typename: 'Organization_Membership' }
      & Pick<Types.Organization_Membership, 'id' | 'memberType'>
    )>, prefs: (
      { __typename: 'Organization_Prefs' }
      & Pick<Types.Organization_Prefs, 'permissionLevel'>
    ), enterprise?: Types.Maybe<(
      { __typename: 'Enterprise' }
      & Pick<Types.Enterprise, 'id' | 'displayName' | 'idAdmins'>
      & { organizationPrefs: (
        { __typename: 'Organization_Prefs' }
        & Pick<Types.Organization_Prefs, 'permissionLevel'>
      ) }
    )>, domain?: Types.Maybe<(
      { __typename: 'DomainOrganization' }
      & Pick<Types.DomainOrganization, 'displayName'>
    )> }
  )> }
);

/**
 * __useWorkspaceSettingsVisibilityQuery__
 *
 * To run a query within a React component, call `useWorkspaceSettingsVisibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceSettingsVisibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceSettingsVisibilityQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useWorkspaceSettingsVisibilityQuery(
  baseOptions: TrelloQueryHookOptions<
    WorkspaceSettingsVisibilityQuery,
    WorkspaceSettingsVisibilityQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: WorkspaceSettingsVisibilityDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    WorkspaceSettingsVisibilityQuery,
    WorkspaceSettingsVisibilityQueryVariables
  >(WorkspaceSettingsVisibilityDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useWorkspaceSettingsVisibilityLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    WorkspaceSettingsVisibilityQuery,
    WorkspaceSettingsVisibilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkspaceSettingsVisibilityQuery,
    WorkspaceSettingsVisibilityQueryVariables
  >(WorkspaceSettingsVisibilityDocument, options);
}
export type WorkspaceSettingsVisibilityQueryHookResult = ReturnType<
  typeof useWorkspaceSettingsVisibilityQuery
>;
export type WorkspaceSettingsVisibilityLazyQueryHookResult = ReturnType<
  typeof useWorkspaceSettingsVisibilityLazyQuery
>;
export type WorkspaceSettingsVisibilityQueryResult = Apollo.QueryResult<
  WorkspaceSettingsVisibilityQuery,
  WorkspaceSettingsVisibilityQueryVariables
>;
